import { StowagePlan } from 'src/types/ViewModel/Stowage/StowagePlan';
import { RotationPortCall } from 'src/types/ViewModel/Stowage/Rotation/RotationPortCall';
import { RotationCargo } from 'src/types/ViewModel/Stowage/Rotation/RotationCargo';
import { mapProducts } from './productUtils';
import { mapRotation } from './stowageRotationUtils';
import { updateManifest } from './manifest/cargoManifestUtils';
import { Product } from 'src/types/ViewModel/Stowage/Product/Product';
import { ProductCategory } from 'src/types/ViewModel/Stowage/Product/ProductCategory';
import { StowageRulesMapsBM } from 'src/types/BusinessModel/Stowage/StowageRule/StowageRulesMapsBM';
import { PortName } from 'src/types/ViewModel/Stowage/Port/PortName';
import { BerthName } from 'src/types/ViewModel/Stowage/Port/BerthName';
import { Vessel } from 'src/types/ViewModel/Vessel/Vessel';

/**
 * Updates stowage data with all dependencies provided as parameters
 *
 * @param stowagePlan - The stowage plan to update
 * @param stowagePlanRotationPortCallList - Port calls for the rotation
 * @param stowagePlanRotationCargoList - Cargo items for the rotation
 * @param productList - List of products
 * @param productCategoryList - List of product categories
 * @param stowageRulesMaps - Maps of stowage rules
 * @param portNameList - List of port names
 * @param berthNameList - List of berth names
 * @param selectedVessel - The currently selected vessel
 */
export const updateStowageDataSimple = (
    stowagePlan: StowagePlan,
    stowagePlanRotationPortCallList: RotationPortCall[],
    stowagePlanRotationCargoList: RotationCargo[],
    productList: Product[],
    productCategoryList: ProductCategory[],
    stowageRulesMaps: StowageRulesMapsBM,
    portNameList: PortName[],
    berthNameList: BerthName[],
    selectedVessel: Vessel
): void => {
    mapProducts(productList, productCategoryList, stowageRulesMaps);
    mapRotation(
        stowagePlan,
        stowagePlanRotationPortCallList,
        stowagePlanRotationCargoList,
        portNameList,
        berthNameList,
        productList,
        selectedVessel,
        []
    );

    updateManifest(stowagePlan, selectedVessel);
};
